// extracted by mini-css-extract-plugin
export default {"productCardDrawerFooter":"styles_product-card-drawer-footer__gM2ji"};